import type { ActionType, PromotionAction, Tier } from './actions';

function fixedTier(): Tier {
	return { id: crypto.randomUUID(), threshold: 0, value: 0 };
}

/** Builds a default action object for a given type (used on add + type switch). */
export function createAction(type: ActionType, combineWithOthers = false): PromotionAction {
	switch (type) {
		case 'percentage-discount':
			return { type, combineWithOthers, tierMode: 'fixed', tiers: [fixedTier()], applyOnDiscountedProducts: 'none' };
		case 'value-discount':
			return { type, combineWithOthers, applicationMode: 'once', tierMode: 'fixed', tiers: [fixedTier()] };
		case 'fixed-price':
			return { type, combineWithOthers, tierMode: 'fixed', tiers: [fixedTier()] };
		case 'bogo':
			return {
				type,
				combineWithOthers,
				x: 2,
				y: 1,
				z: 50,
				sameProductOnly: false,
				reachPricingMode: 'afterDiscount',
				offerProducts: [],
				offerCategories: []
			};
		case 'gift-product':
			return {
				type,
				combineWithOthers,
				maxSelections: 1,
				productIds: [],
				prompts: [
					{ locale: 'el', text: '' },
					{ locale: 'en', text: '' }
				]
			};
		case 'per-product-discount':
			return { type, combineWithOthers, rows: [{ productId: 0, minQty: 1, discount: 0, discountMode: 'percentage', maxQty: null }] };
		case 'category-discount':
			return {
				type,
				combineWithOthers,
				maxChoices: null,
				rows: [{ categoryId: 0, minQty: 1, discount: 0, discountMode: 'percentage', maxQty: null }],
				messages: {}
			};
		case 'shipping-discount':
			return {
				type,
				combineWithOthers,
				rules: [
					{ id: crypto.randomUUID(), shippingMethodId: null, discountType: 'percentage', amount: 0, stopProcessing: false, additive: false }
				]
			};
	}
}
